import { Pipe, PipeTransform } from '@angular/core';
import { OpportunitySummary } from '@features/opportunities/models/opportunity';
import {
  DocumentStatus,
  RequiredDocumentStatus
} from '@shared/models/opportunity';
import { environment } from '@env/environment';

/**
 * Pipe to filter required documents that need attention (invalid/outdated)
 * 
 * Both POS and PAPP use "Outdated" status when regeneration is needed:
 * - POS: Valid → Outdated (with reasons: NewApplicantAdded, CreditAdviceFeeChanged, etc.)
 * - PAPP: Latest → Outdated
 * 
 * Returns documents that are NotGenerated or Outdated (need action)
 */
@Pipe({
  name: 'invalidRequiredDocuments'
})
export class InvalidRequiredDocumentsPipe implements PipeTransform {
  transform(opportunitySummary: OpportunitySummary): RequiredDocumentStatus[] {
    // Skip document validation in development mode to allow easier testing
    if (!environment.production) {
      return [];
    }
    
    return opportunitySummary.summary.requiredDocumentStatus.filter(
      (y) =>
        (y.status === DocumentStatus.NotGenerated ||
          y.status === DocumentStatus.Outdated) &&
        !opportunitySummary.summary.isCommercial
    );
  }
}
